import _extends from 'babel-runtime/helpers/extends';
import React from 'react';

var ButtonWrapper = function ButtonWrapper(props) {
  var style = {
    alignSelf: 'center',
    display: 'inline-flex',
    flexWrap: 'nowrap',
    maxWidth: '100%',
    position: 'relative'
  };
  if (props.fit) {
    style.width = '100%';
    style.justifyContent = 'center';
  }

  var optionalProps = {};
  if (props.onClick) {
    optionalProps.onClick = props.onClick;
  }
  return React.createElement(
    'span',
    _extends({ style: style }, optionalProps),
    props.children
  );
};

export default ButtonWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/button/dist/esm/styled/ButtonWrapper.js
// module id = 388
// module chunks = 0